
<div class="px-3 py-3 pb-1">
    <a routerLink="/" title="RedLaboralRD" class="d-block mt-1 mb-1 mx-auto" style="max-width: 290px;" (click)="toggleMenu()">
        <img src="assets/Images/logo.jpg" class="img-fluid" alt="logo" />
    </a>
    <div class="form-group mb-3">
        <div class="input-group">
            <input type="search" class="form-control" placeholder="Buscar" (input)="onSearchInput($event)" (keyup.enter)="onSearchEnter()"/>
            <button type="button" class="btn btn-primary" (click)="onSearchEnter()">
                <i class="fa-solid fa-magnifying-glass"></i>
            </button>
        </div>
    </div>
</div>
<div class="px-0 app-menu-content">
    <div *ngFor="let section of menuSections" class="list-group list-group-redlaboral mb-1">
        <!-- Encabezado de sección -->
        <ng-container *ngIf="section.title && isAllowed(section.roles)">
            <a class="list-group-item list-group-item-action text-primary"
               [routerLink]="section.mainRoute"
               (click)="toggleMenu()">
                <h5 class="mt-0 mb-0">{{ section.title }}</h5>
            </a>
        </ng-container>

        <!-- Items del menú -->
        <ng-container *ngFor="let item of section.items">
            <a 
            *ngIf="isAllowed(item.roles) || (item?.showWhenLoggedOut && !authService.isLoggedIn())"
           class="list-group-item list-group-item-action"
           [routerLink]="item.route"
           (click)="handleItemClick(item)">
            <i [class]="item.icon"></i>
            {{ item.name }}
        </a>
        </ng-container>
        
    </div>
    
    <!-- Sección de Búsqueda Rápida para usuarios no logueados o candidatos -->
    <div *ngIf="((!currentRole || currentRole === '1') && quickFilters.length > 0)" class="list-group list-group-redlaboral mb-1">
        <a class="list-group-item list-group-item-action text-primary">
            <h5 class="mt-0 mb-0">Búsqueda Rápida</h5>
        </a>
        
        <ng-container *ngFor="let filter of quickFilters">
            <a class="list-group-item list-group-item-action" 
               (click)="navigateToFilter(filter)">
                {{ filter.text }}
                <span *ngIf="filter.relatedId" class="badge bg-primary float-end">{{ filter.relatedId }}</span>
            </a>
        </ng-container>
    </div>
</div>
